const today                         = new Date();
const ms_per_day                    = 1000 * 60 * 60 * 24;
var intersitialFlag                 = 0;
var when_oficina_mobi_was_displayed = new Date(localStorage.getItem("when_oficina_mobi_was_displayed"));

document.addEventListener("visibilitychange", function () {
  if (document.visibilityState === "hidden") {
    viewIntercontent();
  }
});

window.addEventListener("popstate", function(){
  viewIntercontent()
});


jQuery(document).ready(function($) {

  if(intersitialFlag == 0)  window.history.pushState({}, '', new URL(window.location));

  if (window.location.pathname == '/'){
    viewIntercontent();
  }

  //Trigger main post
  if ($('#main_post').length){
    $(window).scroll(function() {
      if ($(window).scrollTop() > $('#main_post').height() / 2.5){
        viewIntercontent()
      }
    });
  }

});

function viewIntersitial(){
  var verifyPubPremium = document.querySelector('.publi-skin-premium, .area-publi-takeover-full')
  if(intersitialFlag == 0 && intersitialAlternateView() && !verifyPubPremium){
    var intersitialScript = document.createElement('script');
    intersitialScript.src = window.location.origin + "/api/leads/intersitial/view";
    document.head.appendChild(intersitialScript);
    intersitialFlag = 1;
  }
}

function intersitialAlternateView(homeView){

  if(sessionStorage.getItem('intersitialCounter') == null){
    sessionStorage.setItem('intersitialCounter', 0);
  }

  var intersitialCounter = parseInt(sessionStorage.getItem('intersitialCounter'),10);

  if  (intersitialCounter>2){
    return false;
  }

  if (homeView || intersitialCounter%2 == 0){
    intersitialCounter++;
    sessionStorage.setItem('intersitialCounter', intersitialCounter);
    return true;
  }

  intersitialCounter++;
  return false;

}

function viewCTAPRM(){
  if(intersitialFlag == 0){
    var ctaPrmScript = document.createElement('script');
    ctaPrmScript.src = window.location.origin + "/api/leads/cta_prm/view";
    document.head.appendChild(ctaPrmScript);
    intersitialFlag = 1;
    localStorage.setItem('cta_prm', new Date().getTime());
  }
}

function viewIntercontent(){

  // var oficina_mobi_displayed_today = dateDiffInDays(when_oficina_mobi_was_displayed) == 0 ? true : false;

  if( localStorage.getItem('has_oficina_mobi') == 'false' )
    viewIntersitial()
}

function dateDiffInDays(a) {

  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());

  return Math.floor((utc2 - utc1) / ms_per_day);
}
